// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3OuZu","content":"GlobalSearch_content__1TSp9"};